import React, { useState, useEffect } from "react";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import { toast } from "react-toastify";
import { getAttorneyBilling } from "../../api/server";
import PaginatedItems from "./pagination";
import { ThreeDots } from "react-loader-spinner";
import { FaEye } from "react-icons/fa";
// import InvoiceModal from "./InvoiceModal";
import { useLocation, useNavigate } from "react-router-dom";
import BillingSourceTabs from "./BillingSourceTabs";
import BillingFilterDropdown from "./BillingFilterDropdown";

const AttorneyPendingBilling = () => {
  const [response, setResponse] = useState([]);
  const [getloading, setGetLoading] = useState(true);
  const [pageCache, setPageCache] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState();
  // const [showModal, setShowModal] = useState(false);
  const [attorneyData, setAttorneyData] = useState();
   const location = useLocation();
  const params = new URLSearchParams(location.search);
    const course = params.get("course");
  const [filter, setFilter] = useState( course || "all");
   
  // const showModal = params.get("show") === "true";
 const navigate = useNavigate();
  const fetchData = async () => {
    // if (!forceRefresh && pageCache[`${pageNo}-${filter}`]) {
    //   const { cachedResponse, cachedTotal } = pageCache[`${pageNo}-${filter}`];
    //   setResponse(cachedResponse);
    //   setTotal(cachedTotal);
    // } else {
      setGetLoading(true);
      await getAttorneyBilling(pageNo, filter) // sending cc / de / all
        .then((res) => {
          const newData = res.data.pendingBilling.result;
          const newTotal = res.data.pendingBilling.total;

          // setPageCache((prevCache) => ({
          //   ...prevCache,
          //   [`${pageNo}-${filter}`]: {
          //     cachedResponse: newData,
          //     cachedTotal: newTotal,
          //   },
          // }));

          setResponse(newData);
          setTotal(newTotal);
          setGetLoading(false);
        })
        .catch((err) => {
          toast.error(err.response?.data.error);
          setGetLoading(false);
        });
    // }
  };

  useEffect(() => {
    fetchData();
  }, [pageNo, filter]);

  return (
    <div>
     
      <div className="wrapper">
        <DashBoardSidebar />
        <div id="content">
          <DashboardNavbar />
          <section className="manage-students language_wrap billing-workspace">
          <BillingSourceTabs activeSource="attorney" view="billing" />
         {/* {
         showModal ?
         <>
        <InvoiceModal
          fetchParentData={fetchData}
          course={filter.toLowerCase()}
          showModal={showModal}
          // setShowModal={setShowModal}
          attorneyData={attorneyData}
        />
         </>
         :
         <>
        
         </>
         } */}
          <div className="pending-billing-toolbar">
              <BillingFilterDropdown
                id="attorney-course-filter"
                label="Course"
                icon="fa-solid fa-graduation-cap"
                value={filter}
                onChange={(selectedValue) => {
                  setPageNo(1); // reset to page 1 when filter changes
                  const params = new URLSearchParams(location.search);
                  params.set("course", selectedValue);
                  const newUrl = `${location.pathname}?${params.toString()}`;
                  window.history.replaceState({}, "", newUrl);
                  setFilter(selectedValue);
                }}
                options={[
                  { value: "all", label: "All" },
                  { value: "first", label: "CC" },
                  { value: "second", label: "DE" },
                ]}
              />
            </div>

            <div className="billing-list-card">
              <div className="billing-list-table-scroll">
                <table className="table glade-billing-table billing-list-table">
                  <thead>
                    <tr>
                      <th>Attorney Name</th>
                      <th>Attorney Email</th>
                      <th>Attorney Code</th>
                      <th>Course</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getloading ? (
                      <tr>
                        <td colSpan={5}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : response && response.length > 0 ? (
                      response.map((billing, index) => (
                        <tr key={index}>
                          <td style={{ color: "#000" }}>{billing?.name}</td>
                          <td>{billing?.email}</td>
                          <td>{billing?.attorneyCode}</td>
                          <td>{billing?.course}</td>
                          <td>
                            <FaEye
                              style={{ cursor: "pointer", color: "black" }}
                              // onClick={() => {
                              //   setAttorneyData(billing);
                              //   // setShowModal(true);
                              //   navigate(`?show=true`)
                              // }}
                              onClick={() => {
                                const courseParam =
                                  billing.course === "CC,DE"
                                    ? "both"
                                    : billing.course === "CC"
                                      ? "first"
                                      : "second";

                                 navigate(`/invoice?course=${filter}`, {
                                  state: {
                                   attorneyData:billing,
                                   courseParam
                                  },
                                });
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5}>No pending Billing found</td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {!getloading && total !== 0 && total > 10 && (
                  <PaginatedItems
                    pageSize={10}
                    total={total}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                  />
                )}
              </div>
            </div>
            
          </section>
        </div>
      </div>
      {/* {showModal && (
        
      )} */}
    </div>
  );
};

export default AttorneyPendingBilling;
